<template>
    <footer>
        <div class="row col-12 p-0 m-0 justify-content-center"><div class="col-auto"><HarrodsLogo class="harrodsLogo" /></div></div>
        <div class="row col-12 d-flex justify-content-center p-0 m-0 mb-3 text" style="font-size:13px">CUSTOMER SERVICE</div>
        <a class="row col-12 d-flex justify-content-center p-0 m-0 mb-3 font-weight-normal text" href="tel:+442077301234">Call: +44 (0)20 7730 1234</a>
        <div class="row col-12 d-flex justify-content-center p-0 m-0 mb-5 font-weight-normal text"><div class="col-auto"><p>Email: <a href="mailto:customer.service@harrods.com"><span class="hyperlink">customer.service@harrods.com</span></a></p></div></div>
            <div class="footerLinks row">
                <a class="hyperlink col-12 col-md-3 mb-3" href="https://www.harrods.com/en-gb/legal/privacy-policy" target="_blank">Privacy Policy</a>
                <a class="hyperlink col-12 col-md-3 mb-3" href="javascript:Didomi.preferences.show()">Cookie Preferences</a>
                <a class="hyperlink col-12 col-md-3 mb-3" href="https://www.harrods.com/en-gb/harrods-rewards" target="_blank">Harrods Rewards</a>
                <a class="hyperlink col-12 col-md-3 mb-3" href="https://www.harrods.com/en-gb/legal/terms-and-conditions" target="_blank">Terms & Conditions</a>
            </div>
    </footer>
</template>

<script>
import HarrodsLogo from '@/components/HarrodsLogo.vue'

export default {
  name: 'SiteFooter',
  props: {
    msg: String
  },
  components: {
    HarrodsLogo
  }
}
</script>

<style lang="scss" scoped>
footer {
    height: 448px;
    width: 100%;
    background-color: $harrods-medium-green;
}

.harrodsLogo {
    margin-top: 70px !important;
    margin-bottom: 40px !important;
}

.text {
    color: $harrods-white;
}

    .footerLinks {
        text-align: center;

        @media screen and (min-width: 850px) {
            margin: 0 10% 0 10%;
        }

        @media screen and (min-width: 1269px) {
            margin: 0 25% 0 25%;
        }
    }
</style>
